import Link from '../../link/link';
import React from 'react';
import { DatoCmsLink, DatoCmsProductTileListItem } from '../../../schema/datocms/blocks';
import { RawImage } from '../../../schema/gatsby';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';

const ProductTileListItemComponent = ({ product, productLink }: DatoCmsProductTileListItem): React.ReactElement => {
    const link: DatoCmsLink | undefined = productLink && productLink.length > 0 ? productLink[0] : undefined;
    const description: JSX.Element = <span className="uppercase font-normal text-center">
        { <HtmlEntityTextComponent text={product.description} /> || product.description }
    </span>;

    const image: RawImage = link ? product.linkLogoImage : product.solidLogoImage;
    let logoAndNameSection = (
        <div className="flex flex-col flex-shrink-0 items-center space-y-2">
            <img src={image.url} alt={image.alt} style={{ width: '7rem'}} />
            <h3 className={`whitespace-nowrap ${link? 'text-theme-secondary' : 'text-theme-primary-text'}`}>{product.name}</h3>

            {!link && description}
        </div>
    );

    if (link) {
        logoAndNameSection = (
            <div className="flex flex-col items-center space-y-2">
                <Link className="flex-shrink-0 flex flex-col items-center space-y-2"
                    internalPageReference={link.internalPageReference}
                    internalPageSectionId={link.internalSectionComponentId}
                    externalPageUrl={link.externalPageUrl}
                    title={link.descriptiveTitle}>
                    {logoAndNameSection}
                </Link>

                {description}
            </div>
        );
    }

    const borderColorClass: string = link ? 'border-theme-secondary hover:border-theme-primary-text' : 'border-theme-primary-text';
    const listItem = (
        <div className={`w-full p-4 border border-1 ${borderColorClass} rounded-xl`}>
            {logoAndNameSection}
        </div>
    );

    return listItem;
};

export default ProductTileListItemComponent;
